import FormController from "components/Molecules/FormController"
import React from "react"
import useDCStore from "../dc.store"
import FormLayout from "../FormLayout"
import LicenceDetail from "./LicenceDetail"
const LicenseDetails = () => {
  const [licenseDetails, onChange, addListItem] = useDCStore(store => [
    store.state.licenseDetails ?? [],
    store.setData("licenseDetails"),
    store.addListItem,
  ])

  return (
    <FormController source={licenseDetails} onChange={onChange}>
      <FormLayout
        title="Licence Details"
        addBtnText="Licence"
        onAdd={() => addListItem("licenseDetails", { hasValidity: "no" })}
      >
        {licenseDetails.map((method, index) => (
          <LicenceDetail key={index} data={method} index={index} />
        ))}
      </FormLayout>
    </FormController>
  )
}

export default LicenseDetails
